/* ============================================================
   ENDURA — Shopify Theme JS
   ============================================================ */

/* announce rotator */
(function(){
  var msgs = [
    "Complimentary shipping, exchanges & returns",
    "Built to last, made to inspire"
  ];
  var i = 0, el = document.getElementById('annText');
  if (!el) return;
  function go(n){ i=(n+msgs.length)%msgs.length; el.style.opacity=0; setTimeout(function(){ el.textContent=msgs[i]; el.style.opacity=1; },220); }
  el.style.transition = 'opacity .22s ease';
  var prev = document.getElementById('annPrev'), next = document.getElementById('annNext');
  if (prev) prev.onclick = function(){ go(i-1); };
  if (next) next.onclick = function(){ go(i+1); };
  setInterval(function(){ go(i+1); }, 6000);
})();

/* header shrink on scroll */
(function(){
  var h = document.getElementById('header');
  if (!h) return;
  window.addEventListener('scroll', function(){
    if (window.scrollY > 30) h.classList.add('shrink'); else h.classList.remove('shrink');
  }, {passive:true});
})();

/* mobile drawer */
(function(){
  var toggle = document.querySelector('.menu-toggle');
  var drawer = document.getElementById('drawer');
  var scrim  = drawer && drawer.querySelector('.drawer__scrim');
  var closeBtn = drawer && drawer.querySelector('.drawer__close');
  if (!toggle || !drawer) return;
  function open(){ drawer.classList.add('open'); document.body.style.overflow='hidden'; }
  function close(){ drawer.classList.remove('open'); document.body.style.overflow=''; }
  toggle.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (scrim) scrim.addEventListener('click', close);
})();

/* scroll-zoom hero driver */
(function(){
  var hero = document.getElementById('heroScroll');
  if (!hero) return;
  var body = document.body, ann = document.querySelector('.lp-announce'), hdr = document.querySelector('.lp-header');
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function setAnnH(){ if(ann) document.documentElement.style.setProperty('--ann-h', ann.offsetHeight+'px'); }
  setAnnH();
  var ticking = false;
  function update(){
    ticking = false;
    var rect = hero.getBoundingClientRect();
    var total = hero.offsetHeight - window.innerHeight;
    var p = total > 0 ? Math.min(Math.max(-rect.top/total,0),1) : 0;
    if (!reduce) hero.style.setProperty('--p', p.toFixed(4));
    var navBand = (ann?ann.offsetHeight:0) + (hdr?hdr.offsetHeight:0);
    body.classList.toggle('solid-nav', rect.bottom <= navBand + 8);
  }
  function onScroll(){ if(!ticking){ ticking=true; requestAnimationFrame(update); } }
  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', function(){ setAnnH(); update(); });
  update();
})();

/* the look carousel */
(function(){
  var media  = document.getElementById('lookMedia');
  var nameEl = document.getElementById('lookName');
  var matEl  = document.getElementById('lookMat');
  if (!media || !nameEl || !matEl) return;

  /* Reads data from the data-looks attribute on the section wrapper */
  var wrapper = document.getElementById('theLookSection');
  var looks = [];
  try { looks = JSON.parse(wrapper && wrapper.dataset.looks || '[]'); } catch(e){}
  if (!looks.length) return;

  var i = 0;
  function show(){
    var l = looks[i];
    media.className = 'ph ph--' + l.tone + ' lp-look__pmedia';
    if (l.image) {
      media.innerHTML = '<img src="' + l.image + '" alt="' + l.name + '" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover">';
    }
    nameEl.textContent = l.name;
    matEl.textContent  = l.material;
  }
  var prev = document.getElementById('lookPrev'), next = document.getElementById('lookNext');
  if (prev) prev.onclick = function(){ i=(i-1+looks.length)%looks.length; show(); };
  if (next) next.onclick = function(){ i=(i+1)%looks.length; show(); };
  show();
})();

/* scroll reveal */
(function(){
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  }, {threshold:0.08});
  document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
})();

/* Shopify cart — add to bag */
(function(){
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
      body: JSON.stringify({id: variantId, quantity: 1})
    })
    .then(function(r){ return r.json(); })
    .then(function(){
      btn.textContent = 'Added ✓';
      /* update cart count bubble */
      return fetch('/cart.js').then(function(r){ return r.json(); });
    })
    .then(function(cart){
      var count = document.querySelector('.cart-count');
      if (count) count.textContent = '(' + cart.item_count + ')';
      setTimeout(function(){ btn.textContent = 'Add to bag'; btn.disabled = false; }, 2000);
    })
    .catch(function(){
      btn.textContent = 'Add to bag';
      btn.disabled = false;
    });
  });
})();

/* product page — ajax add to bag (stay on page, no forced cart redirect) */
(function(){
  var form = document.getElementById('product-form');
  if (!form) return;
  var isAr = document.documentElement.lang === 'ar';
  form.addEventListener('submit', function(e){
    e.preventDefault();
    var input = form.querySelector('input[name="id"]');
    var btn = document.getElementById('add-to-bag-btn');
    if (!input || !input.value) return;
    var original = btn ? btn.innerHTML : '';
    if (btn){ btn.disabled = true; btn.textContent = isAr ? 'جارٍ الإضافة…' : 'ADDING…'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
      body: JSON.stringify({id: input.value, quantity: 1})
    })
    .then(function(r){ return r.json(); })
    .then(function(){ return fetch('/cart.js').then(function(r){ return r.json(); }); })
    .then(function(cart){
      var count = document.querySelector('.cart-count');
      if (count) count.textContent = '(' + cart.item_count + ')';
      if (btn){ btn.textContent = isAr ? 'تمت الإضافة ✓' : 'ADDED ✓'; }
      setTimeout(function(){ if (btn){ btn.innerHTML = original; btn.disabled = false; } }, 2000);
    })
    .catch(function(){ if (btn){ btn.innerHTML = original; btn.disabled = false; } });
  });
})();
